<template>
  <section class="register">
    <div class="box">
      <div class="header">
        <div key="info" class="title">Informações do Assinante</div>
        <div @click="$router.push('/customer')" class="close"><i class="fas fa-times"></i></div>
      </div>
      <form @submit.prevent class="form">
        <!-- Nome -->
        <label>Nome</label>
        <input v-model="customer.name" type="text" :class="{ error : error.includes('name') }" />
        <div v-if="error.indexOf('name') > -1" class="hint">você esqueceu de digitar o nome</div>
        <label>Celular</label>
        <input v-model="customer.phone" type="text" :class="{ error : error.includes('phone') }" />
        <div v-if="error.indexOf('phone') > -1" class="hint">você esqueceu de digitar o celular</div>
        <label>CPF</label>
        <input v-model="customer.document" type="text" :class="{ error : error.includes('cpf') }" />
        <div v-if="error.indexOf('cpf') > -1" class="hint">você esqueceu de digitar o CPF</div>
        <label>E-mail</label>
        <input v-model="customer.login" type="text" :class="{ error : error.indexOf('email') > -1 || error.indexOf('login-exists') > -1 }"/>
        <div v-if="error.indexOf('email') > -1" class="hint">{{ customer.login ? 'E-mail inválido' : 'você esqueceu o e-mail' }}</div>
        <div v-if="error.indexOf('login-exists') > -1" class="hint">Já existe um usuário cadastrado com esse e-mail</div>
        <label>Telegram</label>
        <input v-model="customer.telegram" type="text" placeholder="Usuário do Telegram"/>
        <label>Usuário TradingView</label>
        <input v-model="customer.traddingview" type="text" placeholder="Usuário do TraddingView"/>
        <label>Fonte de onde veio</label>
        <select v-model="customer.fonte">
          <option value="NENHUM">Nenhum</option>
          <option value="TERCIO">Trader de Mesa Proprietária</option>
          <option value="REGIS">Pra cima Traders</option>
          <option value="QE">Quebrando Estruturas</option>
          <option value="ANDERSON">Mesa Prop Americana/Trader Funding</option>
          <option value="EMANUEL">Grupo do EMANUEL</option>
          <option value="SWISS">Swiss Money Global</option>
          <option value="GOOGLE">Google</option>
          <option value="YOUTUBE">Youtube</option>
        </select>
      </form>
      <div class="actions">
        <button @click="$router.push('/customer')" class="button-previous"><i class="fas fa-angle-left"></i><span>Cancelar</span></button>
        <button @click="save" class="button-save"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Confirmar</span></button>
      </div>
    </div>
  </section>
</template>

<script>
import logger from '../../logger'
import { get as getCustomer } from '../../business/api/customer'
import { update } from '../api/customer'

export default {
  name: 'customer',
  props: ['id', 'customerData'],
  data () {
    return {
      loading: false,
      error: [],
      customer: null
    }
  },
  async mounted () {
    if (this.id !== 'new') {
      this.customer = await getCustomer(this.id)
    } else {
      this.active = true
    }
  },
  methods: {
    async save () {
      if (this.loading) return false
      this.loading = true
      console.log(this.customer)
      try {
        this.error = []
        await update(this.customer.userId, this.customer.name, this.customer.login, this.customer.phone, this.customer.document, this.customer.telegram, this.customer.traddingview, this.customer.fonte)
        this.$router.push('/customer')
        this.$message.success('Alteração realizada com sucesso.', { duration: 3000 })
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        } else {
          logger.error(error, this)
        }
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";
.selector_change {
    background-color: #cccccc;
    color: #595959;
    font-size: 0.8em;
    padding: 2.5px;
}
</style>
